class Api {
  static actionTypeEnum = {
    read: "read",
    create: "create",
    update: "update",
    delete: "delete",
  };

  levelId = {};
  isStandAlone = null;
  baseUrl = "";

  constructor(auth) {
    this.levelId = {
      realm: auth.realm?.id,
      org: auth.orgs?.id,
      site: auth.sites?.id,
    };
    this.isStandAlone = this._checkStandAlone();
    this.baseUrl = this._getBaseUrl();

    Api.instance = this;
  }

  static init(auth) {
    Api.instance = null;
    return new Api(auth);
  }

  _checkStandAlone = () => {
    return !this.levelId.org || Object.keys(this.levelId.org).length === 0;
  };

  _getBaseUrl() {
    return this.isStandAlone
      ? "/orgs/:orgId/sites/:siteId"
      : "/ents/:entId/orgs/:orgId/sites/:siteId";
  }

  getRequestParams(method = Api.actionTypeEnum.read, profileUserAccountsId = "") {
    const params = this.isStandAlone
      ? { orgId: this.levelId.realm, siteId: this.levelId.site }
      : {
        entId: this.levelId.realm,
        orgId: this.levelId.org,
        siteId: this.levelId.site,
      };
    let url = `${this.baseUrl}/settings/profileUserAccounts`;
    let apiKey = "";

    if (method === Api.actionTypeEnum.update) {
      url = `${this.baseUrl}/settings/profileUserAccounts/:profileUserAccountsId`;
      params.profileUserAccountsId = profileUserAccountsId;
    }

    switch (method) {
      case Api.actionTypeEnum.read:
        apiKey = `${url}.read`;
        break;
      case Api.actionTypeEnum.create:
        apiKey = `${url}.create`;
        break;
      case Api.actionTypeEnum.update:
        apiKey = `${url}.update`;
        break;
      case Api.actionTypeEnum.delete:
        apiKey = `${url}.delete`;
        break;
      default:
        break;
    }

    return {
      apiKey,
      params,
    };
  }
}

export default Api;
